var map = {
	"./1-cts.webp": 87457,
	"./11-Hewlett-Packard.svg": 74058,
	"./12-tvs.webp": 22724,
	"./13-Tech_Mahindra.webp": 54091,
	"./14-Britannia.webp": 1507,
	"./16-Bosch.webp": 81864,
	"./17-Polaris.webp": 61632,
	"./18-Soliton.webp": 16511,
	"./19-Hyundai.webp": 52260,
	"./20-sanmar.webp": 95684,
	"./21-LarsenToubro.webp": 39469,
	"./22-hatsun.webp": 2269,
	"./23-Vedanta.webp": 31456,
	"./25-Payoda.webp": 71527,
	"./25-nissan.webp": 73675,
	"./26-sirius.webp": 79649,
	"./27-Vernalis.webp": 97609,
	"./29-anristu.webp": 358,
	"./3-infosys.webp": 29698,
	"./30-kalycito.webp": 69791,
	"./31-fanuc.webp": 82145,
	"./31-odessa.webp": 53135,
	"./31-urc.svg": 18292,
	"./34-vuram.webp": 8372,
	"./35-rane.webp": 2228,
	"./36-sakthi.webp": 20575,
	"./38-delphi.webp": 94337,
	"./39-kbr.webp": 43985,
	"./4-accenture.webp": 29102,
	"./40-airlight.webp": 87252,
	"./41-Trimble.webp": 31742,
	"./42-pentafox.webp": 511,
	"./43-josh.webp": 72203,
	"./44-Rapid_Data.webp": 3295,
	"./45-blubridge.webp": 57411,
	"./46-valeo.webp": 35641,
	"./47-Bi3-Logo.webp": 74557,
	"./48-CDW Sirius.webp": 42089,
	"./49-codemagen_logo.webp": 39486,
	"./5-zoho.webp": 20377,
	"./50-jman.webp": 99717,
	"./51.Securin.svg": 82776,
	"./52-Likan.webp": 98552,
	"./53-Rubrik.webp": 46657,
	"./6-Huawei-Logo.webp": 92363,
	"./7-newge.webp": 25637,
	"./8-Mu-sigma.webp": 35778,
	"./9-ELGi.webp": 20038,
	"./Endava Solutions logo.webp": 14279,
	"./Green Collar Agritech Solutions Pvt. Ltd. Logo.webp": 83035,
	"./IamNeo.ai logo.webp": 19351,
	"./Ignitarium logo.webp": 947,
	"./J&F India Pvt. Ltd..webp": 61916,
	"./JPMorgan Chase (1).webp": 17307,
	"./Presidio_logo.webp": 59864,
	"./Radiant global technology logo.webp": 43170,
	"./SKM Groups logo.webp": 3633,
	"./SRC Projects.webp": 42397,
	"./WhatsApp Image 2025-09-15 at 11.27.31 AM.webp": 9538,
	"./WhatsApp Image 2025-09-15 at 11.28.18 AM.webp": 28028,
	"./WhatsApp Image 2025-09-15 at 11.35.49 AM.webp": 5980,
	"./WhatsApp Image 2025-09-15 at 11.45.14 AM.webp": 27065,
	"./WhatsApp Image 2025-09-15 at 11.45.57 AM.webp": 74598,
	"./WhatsApp Image 2025-09-15 at 11.55.18 AM.webp": 34708,
	"./WhatsApp Image 2025-09-16 at 1.43.24 PM.webp": 10367,
	"./WhatsApp Image 2025-09-16 at 1.43.48 PM.webp": 99209,
	"./WhatsApp Image 2025-09-16 at 2.21.06 PM.webp": 30536,
	"./WhatsApp Image 2025-10-09 at 11.26.43 AM.webp": 97007,
	"./WhatsApp Image 2025-10-09 at 11.42.54 AM.webp": 98801,
	"./adrasti_logo.webp": 82857,
	"./bosch.webp": 25972,
	"./brakesindia.webp": 98792,
	"./coreelteh.webp": 79028,
	"./erproots.webp": 78919,
	"./hitech calibration logo.webp": 33473,
	"./icici.webp": 77652,
	"./itc.webp": 9597,
	"./nbase2 logo (1).webp": 68195,
	"./openmynz.webp": 28227,
	"./schneider.webp": 666,
	"./tcs.webp": 95437,
	"./wipro.webp": 33256,
	"./workhall logo.webp": 78858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24211;